<template>
	<div class="container-facility">
		<ja-input
			v-model.trim="userManagementData.firstName"
			:label="$t('firstName')"
			:name="$t('firstName')"
			:max-length="20"
		></ja-input>
		<ja-input
			v-model.trim="userManagementData.lastName"
			:label="$t('lastName')"
			:name="$t('lastName')"
			:max-length="20"
		></ja-input>
		<ja-input
			v-model.trim="userManagementData.email"
			input-type="email"
			:label="$t('email')"
			:name="$t('email')"
			:max-length="50"
			@input="validateEmailFormat"
		></ja-input>
		<div v-show="showMessageError" class="error-msg">{{ emailError }}</div>
		<ja-dropdown
			v-model="userRoleTypeIndex"
			:label="$t('RoleType')"
			:options="userRoleTypeOptions"
			:disabled="isEditingOwnRecord"
			name="RoleType"
		></ja-dropdown>
		<div class="box-facilities">
			<div class="box-facility" :style="{ 'margin-bottom': '25px' }">
				<div
					v-for="(option, index) in userManagementData.userFacilities"
					:key="index"
				>
					<div class="option-facility">
						<input
							:id="option.name"
							v-model="option.isSelected"
							type="checkbox"
							class="checkbox"
							:disabled="isEnable"
							@change="checkedFacility(option)"
						/>
						<label class="heading-5" :for="option.name">
							{{ option.name }}
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="!isSave"
				@click.native="saveUserManagementData"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</div>
</template>
<script>
import { Dropdown, Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import { ID_NEW_CMS, userRoleType, userRoleIds } from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaInput: Input
	},
	mixins: [AdminFacility],
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		},
		facilities: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			userRoleTypeIndex: 0,
			facilitiesData: null,
			userManagementData: null,
			showMessageError: false,
			emailError: ''
		};
	},
	computed: {
		isEnable() {
			return this.selectedFacilityId > 0;
		},
		userRoleTypeOptions() {
			const options = [...userRoleType];
			if (
				this.selectedFacilityId == 0 ||
				this.userData.email == this.dataEdit.email
			) {
				if (this.isSuperAdmin) {
					return options;
				} else if (this.isUSAAdmin) {
					return options.filter(
						role => role.role_ID != userRoleIds.SUPER_ADMIN
					);
				}
			}
			const result = options.filter(
				role =>
					role.role_ID != userRoleIds.SUPER_ADMIN &&
					role.role_ID != userRoleIds.USA_ADMIN
			);
			return result;
		},
		isCreatedNew() {
			return this.userManagementData.user_ID === ID_NEW_CMS;
		},
		isEditingOwnRecord() {
			return (
				!this.isCreatedNew &&
				this.userData.email == this.dataEdit.email &&
				this.selectedFacilityId > 0
			);
		},
		isSave() {
			return (
				this.userManagementData.email !== null &&
				this.userManagementData.lastName !== null &&
				this.userManagementData.firstName !== null &&
				this.userManagementData.selectedFacility !== null &&
				this.userManagementData.userFacilities.length > 0
			);
		}
	},
	watch: {
		userRoleTypeIndex(newIndex) {
			if (newIndex >= 0) {
				const role = this.userRoleTypeOptions[newIndex];
				if (role) {
					this.userManagementData.role_ID = role.role_ID;
					this.userManagementData.cmsRole = role;
				}
			}
		}
	},
	async created() {
		this.$store.commit('setLoading', true);
		this.userManagementData = this.dataEdit;
		this.getUpdateIndex();
		this.$store.commit('setLoading', false);
	},
	methods: {
		getUpdateIndex() {
			if (this.isCreatedNew) {
				const role = { ...this.userRoleTypeOptions[this.userRoleTypeIndex] };
				if (role) {
					this.userManagementData.cmsRole = role;
					this.userManagementData.role_ID = role.role_ID;
				}

				this.userManagementData.userFacilities.forEach(facility => {
					const isEnable = this.isEnable;
					facility.isSelected = isEnable;
					if (isEnable) {
						this.userManagementData.selectedFacility.push(facility.facility_ID);
					}
				});
			} else {
				this.userRoleTypeIndex = this.userRoleTypeOptions.findIndex(
					role => role.role_ID === this.userManagementData.role_ID
				);
				const userRole = this.userRoleTypeOptions.find(
					role => role.role_ID === this.userManagementData.cmsRole.role_ID
				);
				this.userManagementData.role_ID = userRole.role_ID;

				this.userManagementData.userFacilities.forEach(facility => {
					const exists = this.userManagementData.selectedFacility.filter(
						x => x == facility.facility_ID
					);
					facility.isSelected = exists.length > 0;
				});

				this.userManagementData.userFacilities.sort(function(a, b) {
					if (a.isSelected < b.isSelected) {
						return 1;
					}
					if (a.isSelected > b.isSelected) {
						return -1;
					}
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
			}
		},
		validateEmail(email) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(email);
		},
		validateEmailFormat() {
			if (this.validateEmail(this.userManagementData.email)) {
				this.emailError = '';
				this.showMessageError = false;
				return true;
			} else {
				this.emailError = this.$t('importInfo');
				return false;
			}
		},
		checkedFacility(option) {
			const isSelected = this.userManagementData.selectedFacility.includes(
				option.facility_ID
			);

			if (!isSelected) {
				this.userManagementData.selectedFacility.push(option.facility_ID);
			} else {
				const selectedIndex = this.userManagementData.selectedFacility.findIndex(
					facilityId => facilityId === option.facility_ID
				);
				if (selectedIndex !== -1) {
					this.userManagementData.selectedFacility.splice(selectedIndex, 1);
				}
			}
		},
		saveUserManagementData() {
			if (!this.validateEmailFormat()) {
				this.showMessageError = true;
			} else {
				delete this.userManagementData.userFacilities;
				this.$emit('saveUserManagement', this.userManagementData);
			}
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-facility {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.save {
	justify-content: flex-end;
}
.input-label {
	cursor: pointer;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.box-facilities {
	border: 1px solid $button-border;
	width: 100%;
	height: 150px;
	padding: 15px;
	overflow: auto;
}
.option-facility {
	display: flex;
	gap: 10px;
	margin: 5px;
}
</style>
